export const data = {
  general: {
    displayName: "Aman Kumar Singh",
    displayOccupation: "Frontend Developer",
    displayLocation: "India",
    displayEmail: "maskmanaman@gmail.com",
    about:
      "I love combining design and code to build creative solutions for real-world problems. I'm inspired by music, nature, and photography — and the endless ideas I find online.",
  },
  socials: [
    {
      platform: "LinkedIn",
      url: "https://www.linkedin.com/in/maskmanlucifer/",
      color: "#FB6514",
    },
    {
      platform: "Github",
      url: "https://github.com/maskmanlucifer",
      color: "#00BB83",
    },
    {
      platform: "Send Email",
      url: "mailto:maskmanaman@gmail.com",
      color: "#AAAAAA",
    },
  ],
  now: [
    {
      text: "Reducing content consumption.",
    },
    {
      text: "Trying to make peace with boredom.",
    },
  ],
  projects: [
    {
      title: "lucifer.loops",
      description:
        "An instagram page where I post my animation learning progress.",
      projectUrl: "https://www.instagram.com/lucifer.loops/",
      status: "Live",
    },
    {
      title: "Intent",
      description:
        "A personal task manager designed to help you focus on what matters most.",
      projectUrl: "https://maskmanlucifer.github.io/intent-site/",
      status: "Live",
    },
    {
      title: "Unsplash",
      description:
        "A visual diary from my journey of learning to see — capturing light, textures, and quiet moments through my lens.",
      projectUrl: "https://unsplash.com/@maskmanlucifer",
      status: "Live",
      animation: "characters",
    },
    {
      title: "Argus Inspector",
      description:
        "A lightweight Chrome extension to inspect, measure, and edit any element on any page — without opening DevTools.",
      projectUrl: "https://maskmanlucifer.github.io/argus/",
      status: "Live",
    },
    {
      title: "SizeUp",
      description:
        "A Chrome extension that saves your family's measurements and shows the right clothing sizes — right on product pages of Myntra, Amazon, and Flipkart.",
      projectUrl: "https://maskmanlucifer.github.io/sizeup/",
      status: "Live",
    },
    {
      title: "Mosaix",
      description:
        "A photomosaic generator that creates a large image from many smaller ones.",
      projectUrl: "https://www.figma.com/design/8l7OdrvpfGstCc3tDo2AJ4/Mosaix",
      status: "Archived",
    },
    {
      title: "Maskman",
      description: "A portfolio design project for learning Figma basics.",
      projectUrl: "https://www.figma.com/design/PwmH3niTQXeJVGgTCO32bJ/Mark-Portfolio",
      status: "Archived",
    },
  ],
  books: [
    {
      title: "An Immense World",
      author: "Ed Yong",
      status: "Reading",
      url: 'https://ik.imagekit.io/rkfjdo52u/81F24qra4jL._AC_UF1000,1000_QL80_.jpg',
      year: 2026,
    },
    {
      title: "To kill a mockingbird",
      author: "Harper Lee",
      status: "Read",
      url: 'https://ik.imagekit.io/rkfjdo52u/56916837.jpg',
      year: 2025,
    },
    {
      title: "Galileo's daughter",
      author: "Dava Sobel",
      status: "Read",
      url: 'https://ik.imagekit.io/dnz8iqrsyc/18646.jpg',
      year: 2025,
    },
    {
      title: "Surely you're joking Mr. Feynman",
      author: "Richard Feynman",
      status: "Read",
      url: 'https://ik.imagekit.io/dnz8iqrsyc/35167685.jpg',
      year: 2025,
    },
    {
      title: 'Tuesdays with Morrie',
      author: 'Mitch Albom',
      status: 'Read',
      img: 14,
      url: 'https://ik.imagekit.io/rkfjdo52u/6900.jpg',
      year: 2025,
    },
    {
      title: 'Design as Art',
      author: 'Bruno Munari',
      status: 'Reading',
      img: 13,
      year: 2026,
    },
    {
      title: 'Godan',
      author: 'Munshi Premchand',
      status: 'Read',
      img: 12,
      year: 2025,
    },
    {
      title: "Sprint",
      author: "Jake Knapp",
      status: "Read",
      img: 11,
      year: 2025,
    },
    {
      title: "Gunaahon Ka Devta",
      author: "Dharamvir Bharati",
      status: "Read",
      img: 10,
      year: 2025,
    },
    {
      title: "The Myth of Sisyphus",
      author: "Albert Camus",
      status: "Read",
      img: 9,
      year: 2025,
    },
    {
      title: "Gaban",
      author: "Munsi Premchand",
      status: "Read",
      img: 7,
      year: 2025,
    },
    {
      title: "The Little Book of Alpaca Philosophy",
      author: "Jennifer McCartney",
      status: "Read",
      img: 8,
      year: 2025,
    },
    {
      title: "Sapiens",
      author: "Yuval Noah Harari",
      status: "Read",
      img: 6,
      year: 2025,
    },
    {
      title: "Normal People",
      author: "Sally Rooney",
      status: "Read",
      img: 2,
      year: 2025,
    },
    {
      title: "The Shortest History of India",
      author: "John Zubrzycki",
      status: "Read",
      img: 4,
      year: 2025,
    },
    {
      title: "If Cats Disappear from the World",
      author: "Genki Kawamura",
      status: "Read",
      img: 1,
      year: 2025,
    },
    {
      title: "A Man Called Ove",
      author: "Fredrik Backman",
      status: "Read",
      img: 3,
      year: 2025,
    },
    {
      title: "Make Time",
      author: "Jake Knapp",
      status: "Read",
      img: 5,
      year: 2025,
    },
  ],
  updatedOn: "22/07/2024",
};

export const WORK = [
  {
    title: "Frontend Developer",
    company: "Titan mail",
    date: "2022 - Present",
    logoUrl: "https://ik.imagekit.io/8tmvchj44/titan.png"
  },
  {
    title: "Backend Developer Intern",
    company: "Sharechat",
    date: "2021 - 2022",
    logoUrl: "https://ik.imagekit.io/8tmvchj44/sharechat.png"
  },
];